import React, { useState, useEffect } from "react";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { Paper } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

const DefineChallanInstructions = () => {
  const authtoken = localStorage.getItem("userToken");
  const user = JSON.parse(localStorage.getItem("userDetails"));

  // Add States
  const [addModal, setAddModal] = useState(false);
  const [instructionText, setInstructionText] = useState("");
  const [instructionTitle, setInstructionTitle] = useState("");
  const [instructionType, setInstructionType] = useState("English");
  const [isActive, setIsActive] = useState(true);
  const [addLoading, setAddLoading] = useState(false);

  // Edit States
  const [editModal, setEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editInstructionText, setEditInstructionText] = useState("");
  const [editInstructionTitle, setEditInstructionTitle] = useState("");
  const [editInstructionType, setEditInstructionType] = useState("English");
  const [editIsActive, setEditIsActive] = useState(true);

  // Delete States
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteableInstruction, setDeleteableInstruction] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // General States
  const [instructions, setInstructions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAllFields, setIsAllFields] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const alert = useAlert();

  useEffect(() => {
    getInstructions();
  }, []);

  // ─── GET ALL ───────────────────────────────────────────────
  const getInstructions = async () => {
    setLoading(true);
    await fetch(`${baseUrl}/challan-instructions`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          console.log(data.payload, "Challan Instructions");
          setInstructions(data.payload);
          setLoading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setLoading(false);
      });
  };

  // ─── GET SINGLE FOR EDIT ───────────────────────────────────
  const getEditInstruction = async (id) => {
    await fetch(`${baseUrl}/challan-instructions/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          console.log(data.payload, "Edit Instruction");
          setEditInstructionTitle(data.payload?.title);
          setEditInstructionText(data.payload?.instruction);
          setEditInstructionType(data.payload?.type);
          setEditIsActive(data.payload?.is_active == 1 ? true : false);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  // ─── ADD ───────────────────────────────────────────────────
  const addInstructionHandler = async () => {
    if (instructionText == "" || instructionType == "") {
      setIsAllFields(true);
      return;
    }
    setIsAllFields(false);
    setAddLoading(true);

    const data = {
      title: instructionTitle,
      instruction: instructionText,
      type: instructionType,
      is_active: isActive ? 1 : 0,
    };

    console.log(data);

    await fetch(`${baseUrl}/challan-instructions`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setAddLoading(false);
          if (data.metadata.success) {
            setAddModal(false);
            setInstructionText("");
            setInstructionTitle("");
            setInstructionType("English");
            setIsActive(true);
            alert.show("Instruction added successfully");
            getInstructions();
          } else {
            alert.show("Something Went Wrong");
          }
        }),
      )
      .catch((err) => {
        setAddLoading(false);
        setAddModal(false);
        console.log(err);
      });
  };

  // ─── UPDATE ────────────────────────────────────────────────
  const updateInstructionHandler = async () => {
    if (editInstructionText == "" || editInstructionType == "") {
      setIsAllFields(true);
      return;
    }
    setIsAllFields(false);
    setSubmitLoading(true);

    const data = {
      title: editInstructionTitle,
      instruction: editInstructionText,
      type: editInstructionType,
      is_active: editIsActive ? 1 : 0,
    };

    console.log(data);

    await fetch(`${baseUrl}/challan-instructions/${editId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setSubmitLoading(false);
          if (data.metadata.success) {
            setEditModal(false);
            alert.show("Instruction updated successfully");
            getInstructions();
          } else {
            alert.show("Something Went Wrong");
          }
        }),
      )
      .catch((err) => {
        setSubmitLoading(false);
        setEditModal(false);
        console.log(err);
      });
  };

  // ─── DELETE ────────────────────────────────────────────────
  const deleteInstructionHandler = async () => {
    setDeleteLoading(true);

    await fetch(`${baseUrl}/challan-instructions/${deleteableInstruction.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          alert.show(data.payload);
          getInstructions();
          setDeleteLoading(false);
          setDeleteModal(false);
        } else {
          setDeleteLoading(false);
          setDeleteModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setDeleteLoading(false);
        setDeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {/* ── Add Button ── */}
        <div>
          <button
            onClick={() => setAddModal(true)}
            className="btn btn-primary mr-2"
          >
            Add New Instruction
          </button>
        </div>

        {/* ── Table ── */}
        <div>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">ID</th>
                <th className="text-center">Order</th>
                <th className="text-center">Title</th>
                <th className="text-center">Instruction</th>
                <th className="text-center">Type</th>
                <th className="text-center">Status</th>
                <th className="text-center">Edit</th>
                <th className="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              {instructions.length > 0 &&
                instructions?.map((item) => (
                  <tr key={item?.id}>
                    <td className="text-center">{item?.id}</td>
                    <td className="text-center">{item?.order}</td>
                    <td className="text-center">{item?.title}</td>
                    <td className="text-center">{item?.instruction}</td>
                    <td className="text-center">
                      <span className={`badge btn-primary`}>{item?.type}</span>
                    </td>
                    <td className="text-center">
                      {item?.is_active == 1 ? (
                        <span className="badge btn-primary">Active</span>
                      ) : (
                        <span className="badge btn-danger">Inactive</span>
                      )}
                    </td>
                    <td className="text-center">
                      <a
                        className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                        onClick={() => {
                          setEditId(item?.id);
                          getEditInstruction(item?.id);
                          setEditModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                    <td className="text-center">
                      <a
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                        onClick={() => {
                          setDeleteableInstruction(item);
                          setDeleteModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Delete-user.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          <div className="row justify-content-center">
            {loading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
        </div>

        {/* ─────────────────────────────────────────── */}
        {/* Add Instruction Modal                       */}
        {/* ─────────────────────────────────────────── */}
        <Modal show={addModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Instruction
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <label>Title</label>
                <input
                  className="form-control"
                  placeholder="Enter Instruction Title (Optional)"
                  value={instructionTitle}
                  onChange={(e) => setInstructionTitle(e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <label>
                  Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  value={instructionType}
                  onChange={(e) => setInstructionType(e.target.value)}
                  style={{ backgroundColor: "white" }}
                >
                  <option value="English">English</option>
                  <option value="Urdu">Urdu</option>
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <label>
                  Instruction <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter Instruction Text"
                  value={instructionText}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setIsAllFields(true);
                    } else {
                      setIsAllFields(false);
                    }
                    setInstructionText(e.target.value);
                  }}
                />
              </div>
            </div>

            <br />
            {isAllFields ? (
              <Alert
                variant="danger"
                onClose={() => setIsAllFields(false)}
                dismissible
              >
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>Please fill all required fields</p>
              </Alert>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addInstructionHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddModal(false);
                setIsAllFields(false);
                setInstructionText("");
                setInstructionTitle("");
                setInstructionType("English");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* ─────────────────────────────────────────── */}
        {/* Edit Instruction Modal                      */}
        {/* ─────────────────────────────────────────── */}
        <Modal show={editModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Instruction
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <label>
                  Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  value={editInstructionType}
                  onChange={(e) => setEditInstructionType(e.target.value)}
                  style={{ backgroundColor: "white" }}
                >
                  <option value="English">English</option>
                  <option value="Urdu">Urdu</option>
                </select>
              </div>

              <div className="col-md-6">
                <label>
                  Status <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  value={editIsActive}
                  onChange={(e) => setEditIsActive(e.target.value == "true")}
                  style={{ backgroundColor: "white" }}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mt-3">
                <label>Title</label>
                <input
                  className="form-control"
                  placeholder="Enter Instruction Title (Optional)"
                  value={editInstructionTitle}
                  onChange={(e) => setEditInstructionTitle(e.target.value)}
                />
              </div>

              <div className="col-md-12 mt-3">
                <label>
                  Instruction <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter Instruction Text"
                  value={editInstructionText}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setIsAllFields(true);
                    } else {
                      setIsAllFields(false);
                    }
                    setEditInstructionText(e.target.value);
                  }}
                />
              </div>
            </div>

            <br />
            {isAllFields ? (
              <Alert
                variant="danger"
                onClose={() => setIsAllFields(false)}
                dismissible
              >
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>Please fill all required fields</p>
              </Alert>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {submitLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={updateInstructionHandler}
              >
                Update
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setEditModal(false);
                setIsAllFields(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* ─────────────────────────────────────────── */}
        {/* Delete Instruction Modal                    */}
        {/* ─────────────────────────────────────────── */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure you want to delete?
            </Modal.Title>
          </Modal.Header>
          {deleteLoading ? (
            <div style={{ padding: "20px" }}>
              <b style={{ color: "green" }}>
                Deleting Please Wait <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteInstructionHandler}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setDeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
};

export default DefineChallanInstructions;
